import RedoIcon from '@atlaskit/icon/core/redo';
import * as React from 'react';

export function SvgRedoAlt() {
  return <RedoIcon label="" testId="ads-refreshed-icon" />;
}
